
/**
 * Meta API Constants
 */

// API version
export const API_VERSION = "v18.0";

// App ID - this is public
export const META_APP_ID = "650922480651123";

// Default redirect URI
export const DEFAULT_REDIRECT_URI = "https://app.hoss-immo.de/meta-auth";

// Scopes needed for the application
export const META_SCOPES = [
  "ads_management",
  "ads_read",
  "read_insights",
  "business_management",
  "public_profile"
];

// Date presets for insights
export const INSIGHTS_DATE_PRESETS = [
  { id: "today", name: "Heute" },
  { id: "yesterday", name: "Gestern" },
  { id: "this_week", name: "Diese Woche" },
  { id: "last_week", name: "Letzte Woche" },
  { id: "this_month", name: "Dieser Monat" },
  { id: "last_month", name: "Letzter Monat" },
  { id: "this_quarter", name: "Dieses Quartal" },
  { id: "last_3d", name: "Letzten 3 Tage" },
  { id: "last_7d", name: "Letzten 7 Tage" },
  { id: "last_14d", name: "Letzten 14 Tage" },
  { id: "last_28d", name: "Letzten 28 Tage" },
  { id: "last_30d", name: "Letzten 30 Tage" },
  { id: "last_90d", name: "Letzten 90 Tage" }
];
